import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-app-online-payment-success',
  templateUrl: './app-online-payment-success.component.html',
  styleUrls: ['./app-online-payment-success.component.scss']
})
export class AppOnlinePaymentSuccessComponent implements OnInit {

  constructor(private router: Router, private aRoute: ActivatedRoute) { }

  ngOnInit(): void {
  }

  continue(){
    this.router.navigate(['/', 'home']);
  }

}
